module.exports = __webpack_public_path__ + "img/ideal.2aa3ec11.svg";